require("expose-loader?$!jquery");
require("expose-loader?jQuery!jquery");



// WEBPACK FOOTER //
// ./src/script/jquery-wrapper.ts